import { useEffect } from "react";
import { Theme } from "@radix-ui/themes";

import { Provider } from "react-redux";
import { store } from "./store";
import { Toaster } from "react-hot-toast";
import { initTranslation } from "./i18n";
import { PostHogProvider } from "@posthog/react";
import { disableSwipeNavigation } from "./shared/lib/disable-swipe-navigation";
import { KioskAppShell } from "./app/kiosk-app-shell";

initTranslation();

const options = {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  defaults: "2026-01-30",
} as const;

function App() {
  useEffect(() => disableSwipeNavigation(), []);

  return (
    <Provider store={store}>
      <PostHogProvider
        apiKey={import.meta.env.VITE_POSTHOG_PROJECT_TOKEN}
        options={options}
      >
        <Theme grayColor="mauve">
          <KioskAppShell />
        </Theme>
        <Toaster position="top-center" reverseOrder={false} />
      </PostHogProvider>
    </Provider>
  );
}

export default App;
